export enum NoticeTypeEnums {
    Initial = 1,
    Second = 2,
    ThirtyDay = 30,
    SixtyDay = 60,
    NinetyDay = 90,
    Final = 120,
}
